import React from 'react';
import { ChannelBox } from '../../../components/channel/box';
import { useDevicesAndChannelsContext } from '../../../context/devices-and-channels';
import BinarySensorType from '../components/binary-sensor-type';

const BinarySensorConfiguration: React.FC = () => {
  const { channel } = useDevicesAndChannelsContext();

  if (!channel) return null;

  return (
    <>
      <ChannelBox channel={channel} isListItem noRedirect />
      <BinarySensorType channel={channel} />
    </>
  );
};

export default BinarySensorConfiguration;
